<template>
  <div :class="data.modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card location-addto-cart-modal is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title has-text-weight-bold"> {{ success ? 'Item Added' : 'Add to cart' }}</p>	
      </header>
      
      <section class="modal-card-body ph20">
       <template v-if="loaded">

          <div class="location-landing-addto-cart-wrapper has-text-centered" v-if="success">
            <img src="@/assets/img/icon-basket.svg" alt="image" />
            <p>{{ productDetail.brand.name }}<br/>
              {{ productDetail.name }}<br/>
              {{ selectedVariant.size }} X {{ qty }}<br/>
              ${{ ( (selectedVariant.sale_price > 0 && (selectedVariant.sale_price < selectedVariant.price) ? selectedVariant.sale_price : selectedVariant.price ) * qty).toFixed(2)}}<br/>
            </p>
          </div>

          <div class="location-landing-addto-cart-wrapper" v-else>
            <p class="brand has-text-weight-bold mb-3">{{ productDetail.brand.name }}</p>
             <div class="add-to-cart-images">
               <div class="product-img-wrapper" v-if="productDetail.images && productDetail.images.length > 0">
                <owl-carousel name="addtocart-carousel" :autoplay="true" :autoplayTimeout="parseInt(13000)" :nav="false" :items="1" :dots="true" ><!-- 10000 kind of not working on realtime -->
                  <div class="location-product-carousel-img-wrapper"  v-for="(img, index) in productDetail.images" v-bind:key="'img_' + index">
                    <img :src="img.product_image" :alt="productDetail.name">
                  </div>
                </owl-carousel>
              </div>
              <img v-else src="@/assets/img/leaf.png" class="default-thumb" :alt="productDetail.name" />
             </div>
            <h4 class="has-text-weight-bold mb-3 product-name">
              {{ productDetail.name }}
              <a href="#" v-if="!isGuest"  @click.prevent="isFavProduct ? unFavouriteProduct() : favouriteProduct()" :class="isFavProduct ? 'fav-product' : ''">
                <i :class="isFavProduct ? 'fas fav-btn fa-heart' : 'far fav-btn fa-heart'"></i>
              </a>
            </h4>

            <div class="is-flex justify-content-around mb20 pv20" v-if="productDetail && (productDetail.product_family == 'cannabis') && (productDetail.cannabis_attributes || productDetail.thc_cbd_levels)">
              <!-- <div
                v-if="productDetail && productDetail.cannabis_attributes"
                class="product-feature is-flex is-flex-column justify-content-between align-items-center">
                <img  v-if="productDetail.cannabis_attributes" :src="product_form[productDetail.cannabis_attributes.product_form]" :alt="productDetail.cannabis_attributes.product_form">
                <div class="feature-text" v-text="productDetail.cannabis_attributes.product_form"></div>
              </div> -->
              <div
                v-if="productDetail && productDetail.cannabis_attributes"
                class="product-feature is-flex is-flex-column justify-content-between align-items-center">
                <img v-if="productDetail.cannabis_attributes" :src="plant_type[productDetail.cannabis_attributes.plant_type]" :alt="productDetail.cannabis_attributes.plant_type">
                <div class="feature-text has-text-black" v-text="productDetail.cannabis_attributes.plant_type"></div>
              </div>
              <div
                v-if="productDetail"
                class="product-feature is-flex is-flex-column justify-content-between align-items-center">
                <span class="">THC</span>
                <div class="feature-text has-text-black" v-if="thc">{{ thc }}</div>
                <div class="feature-text has-text-black" v-else>N/A</div>
              </div>
              <div
                v-if="productDetail"
                class="product-feature is-flex is-flex-column justify-content-between align-items-center">
                <span class="">CBD</span>
                <div class="feature-text has-text-black" v-if="cbd">{{ cbd }}</div>
                <div class="feature-text has-text-black" v-else>N/A</div>
              </div>
            </div> 

            <div class="sizes-section">
              
        
              <!-- variants -->
              <template v-if="location_product_variants.length > 0">
                 
                  <!-- this is select view -->
                  <div class="product-attr sizes-section product-sizes mb30" v-if="variantDisplayType == 'select'">
                    <template v-if="totalNumberOfAddableVariants > 0">
                      <h4 class="has-text-weight-bold mb-3">Select size</h4>
                      <select v-model="selectedVariant" class="select-product-variant has-text-dark font-color" >
                        <option :value="{}" selected>Please Choose:</option>
                        <option :disabled="item._in_stock == false"  :value="item" v-for="item in location_product_variants" v-bind:key="'select_item_variant_' + item.id">{{ item.size }}</option>
                      </select>
                    </template>
                  </div>

                  <!-- this is item view -->
                  <template v-else>
                  <h4 class="has-text-weight-bold mb-3">Select size</h4>
                    <div class="columns is-multiline is-flex-mobile" >
                      
                      <div :class="'column is-3 mb10 relative has-fixed-width-variant'" v-bind:key="'variant_' + index" v-for="(variant, index) in location_product_variants">
                        <div class="product-detail-variant-item">
                          <a v-if="variant._in_stock == false" href="#" class="outof-stock-overlay"></a>
                          <div :class="(variant._in_stock == false ?  'control is-out-of-stock variant-block has-text-centered ' : 'control variant-block has-text-centered ') +  (variantHasSalePrice(variant) ? ' has-sale' : '')">
                            <input class="is-checkradio is-block" :id="'product-variant-' + index" type="radio"
                              name="product-variant" v-model="selectedVariant" :value="variant">
                            <label :for="'product-variant-' + index"
                              class="is-flex is-flex-column align-items-center justify-content-center">
                              <div class="variant-item-block has-text-centered">
                                <div class="variant-weight has-text-weight-semibold">{{ variant.size }}</div>
                              </div>
                            </label>
                            <div class="sale-attach is-size-11" v-if="variantHasSalePrice(variant)">
                              {{ variantSalePercentage(variant) }}
                            </div>
                          </div>
                        </div>
                        <div class="variant-attributes-at-footer">
                          <div class="variant-price has-text-dark has-text-weight-bold">${{ (variant.sale_price > 0 && (variant.sale_price < variant.price)) ? variant.sale_price.toFixed(2) : variant.price.toFixed(2) }}</div>
                          <div class="variant-unit-price has-text-centered" v-if="productDetail.product_family == 'cannabis'">
                            <template v-if="variant.weight_equivalent_dry_cannabis">
                              <div v-html="itemPricePerWeight(variant)"></div>
                            </template>
                          </div>

                        </div>

                      </div>
                    </div>
                  </template>

              </template>
            </div>

            <div class="add-to-cart-heading is-flex mt-2 mb-2 is-justify-content-space-between">
              <p class="">Add to cart</p>
              <p class="has-text-right">${{ totalPrice }}</p>
            </div>

            <div class="quantity-block is-flex justify-content-between">
              <button @click="decreaseQty()" class="button minus is-borderless " value="-"><i class="fas fa-minus"></i></button>
              <div class="field mb0">
                <div class="control disable-click-event">
                  <!-- <input v-model="qty" class="input pointer-none is-shadowless has-text-centered" type="number" value="1"
                    min="0"> -->
                  <span v-text="qty" class="display-qty has-text-weight-bold has-text-black "></span>
                </div>
              </div>
              <button @click="increaseQty()" class="button plus is-borderless " value="+"><i class="fas fa-plus"></i></button>
            </div>

        </div>
         <!-- {{ productDetail }} -->
          <!-- <img src="@/assets/img/icon-basket.svg" alt="Basket" class="mt20 mb20">
          <p class="modal-card-title is-size-14 mb10 mb15">Are you sure ?</p> -->
       </template>
       <template v-else>
         <loading />
       </template>
      </section>

      <footer class="modal-card-foot" v-if="loaded">
          <template v-if="totalNumberOfAddableVariants > 0">

            <div class="next-prev-button" v-if="success">
              <a class="default-btn is-large is-primary-outline is-full-width mb-3" 
                href="#"
                @click.prevent="viewCart()"
                >VIEW CART</a>
              <button class="button is-large is-primary is-full-width" @click.prevent="closeModal()">CONTINUE SHOPPING</button>
            </div>

            <div class="next-prev-button" v-else>
              <a @click.prevent="callback(productDetail)" href="#" class="default-btn is-large is-primary-outline is-full-width mb-3">
                MORE INFO
              </a>
              <button v-if="!isEmptyObj(selectedVariant)" class="button is-large is-fixed-add-to-cart is-full-width" @click.prevent="addTocart()">ADD TO STASH</button>
              <button v-else class="button is-large has-background-danger-dark is-full-width">Please select a variant.</button>
            </div>

          </template>
          <template v-else>
             <button class="button is-large has-background-danger-info is-full-width">No variants availabe to add</button>
          </template>
       
      </footer>
    </div>
  </div>
</template>


<script>
import Env from "@/env";
import ProductApis from '@/Components/Controllers/ProductApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import * as _ from 'lodash';
import { mapGetters, mapActions} from 'vuex';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'LocationLandingAddTocart',
  props:{
    callback: { type: Function },
  },
  data() {
    return {
      variantDisplayType: 'list',
      qty: 1,
      totalNumberOfAddableVariants: 0,
      loaded: false,
      productDetail: {       
      },
      location_product_variants: [],
      data: {
        modal: false,
        product: {},
      },
      selectedVariant: {
      },
      success: false,
      favDetail: {},
    };
  },
  computed: {
     ...mapGetters({
      vg_cartId: 'cart/id',
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_weightOnCart: "cart/cartWeight",
      vg_favProducts: "favouriteproducts/list",
      vg_guestLandedQueries: "location/guestLandedQueries",
    }),
    
    

    is_user_logged_in() {
      return this.$store.getters.getLoggedInUserToken;
    },
    product_form() {
      return Env.product_form;
    },
    plant_type() {
      return Env.product_type;
    },
    totalPrice (){
      if(_.isEmpty(this.selectedVariant)){
        return 0.00.toFixed(2);
      }
      if( this.selectedVariant.sale_price > 0 && (this.selectedVariant.sale_price < this.selectedVariant.price) ) { 
        return (this.selectedVariant.sale_price * this.qty).toFixed(2);
      } 
      return (this.selectedVariant.price * this.qty).toFixed(2);
    },
    isGuest() {
      if( (this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only']){
        return true;
      } else if(this.$store.getters.getLoggedInUserToken){
        return false;
      }
      return true;
    },
    isFavProduct() {
     const self = this;
     let favObj = _.find(this.vg_favProducts, function(o) { return o.id == self.productDetail.id; });
      if(favObj != undefined){
        this.favDetail = favObj;
        return true;
      }
      return false;
    },
    thc() {
      return Helpers.getTHCValue(this.productDetail);
    },
    cbd() {
      return Helpers.getCBDValue(this.productDetail);
    },
  },

  mounted() {
    bus.$on('location-landing-addto-cart', (payload) => {
      this.data = payload;
    })
  },

  beforeDestroy() {
    bus.$off('location-landing-addto-cart');
  },

  watch: {
    'data.modal': async function(){
      const self = this;
      // if product modal is tru we have data on it fetch location product detail from that
      if(this.data.modal == true){
        let product_id = this.data.product.id;
        let res = await ProductApis.fetchById(product_id);
         if(res.status != 200){
          this.va_snackbar({
            type: 'warning', 
            message: 'Sorry no variants available.',
          });
          return this.closeModal();
         }
        this.productDetail = res.data.payload;
        
        // lets save the data on vbout

        if(this.$store.getters.getLoggedInUserToken){
          VboutApis.productView(this.productDetail, Helpers.getLocationProductFullUrl(this, this.productDetail.id), this.vg_selectedStore.id);
        }
        
        this.location_product_variants = this.selectedLocationVariants(this.productDetail.product_family, this.productDetail.variants)
        this.variantDisplayType = Helpers.getVariantDisplayType(this.location_product_variants);
        this.totalNumberOfAddableVariants = Helpers.getTotalNumberOfAddableVariants(this.location_product_variants);

        if(this.totalNumberOfAddableVariants == 1){
          // if the available variant is only 1 make it auto selected
          this.selectedVariant =  Helpers.getFirstAvailableVariant(this.location_product_variants);
        }
          
        this.loaded = true;
        // G track impression
        this.$gtag.event('view_item', 
          {
            items: [
              {
                id: this.productDetail.id,  
                name: this.productDetail.name, 
                list: null,
                brand: this.productDetail.brand ? this.productDetail.brand.name : null,
                category: this.productDetail.category ? this.productDetail.category.name : null,
                variant: this.selectedVariant.size,
                position: '',
                price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
              }
            ]
          } 
        )
      }
    },
  },

  methods: {
    /**
     * Add to cart
     */
    async addTocart() {
   

       // If we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }

      // threshold 
      if(this.totalNumberOfAddableVariants < 1){
        return this.va_snackbar({
          type: 'warning', 
          message: 'Products variants are not available.',
        });
      }

       // Check if variant is selected 
      if( _.isEmpty(this.selectedVariant) ) {
        return this.va_snackbar({
          type: 'warning', 
          message: 'Please Select Weight & Price.',
        });
      }

   
      // If already exceed limit
      if(this.vg_weightOnCart > 30.00){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }
     
      // If going to exceed limit on adding this item
      let currentProductWeight = this.qty * parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);
    
      if(finalWeight > 30.00) {
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.productDetail.id), location_product_variant_id: parseInt(this.selectedVariant.id) });
 
      if(checkExistingProduct == undefined){
        // validate if we have instock
        if(parseInt(this.qty) > this.selectedVariant.no_of_units){
          // reject cannot add qty more than no of units
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        let result = await this.addCartItem();
        if(result == true){
          this.success = true;
        }
  
      } else {
        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units) - parseInt(existingProductQty);
        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        let result = await this.updateCartItem(checkExistingProduct);
        if(result){
          this.success = true;
        }
      }
    },

    /**
     * Add cart item
     */
    async addCartItem() {

      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.productDetail.id,
        category_id: this.productDetail.category_id ? this.productDetail.category_id : null,
        category_name: this.productDetail.category ? this.productDetail.category.name : null,
        thc_cbd_value_type: this.productDetail.category ? this.productDetail.category.thc_cbd_value_type : '',
        product_name: this.productDetail.name,
        product_family: this.productDetail.product_family,
        product_id: this.productDetail.id,
        product_image: this.productDetail.image ? this.productDetail.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.productDetail.product_type ? this.productDetail.product_type : '',
        brand_name: this.productDetail.brand ? this.productDetail.brand.name : '',
        location_product_variant_id: this.selectedVariant.id,
        location_variant_sku: this.selectedVariant.sku,
        location_product_variant_external_sku: this.selectedVariant.external_id,
        price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price, // if has sale price & sale must be lower than regular, then use sale else regular price
        actual_price: this.selectedVariant.price,
        weight: this.selectedVariant.weight_equivalent_dry_cannabis ? this.selectedVariant.weight_equivalent_dry_cannabis : 0,
        unit: parseInt(this.qty),
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.productDetail, // triple to match fav style
        selected_variant: this.selectedVariant,        
        weighing_unit: this.productDetail.weighing_unit ? this.productDetail.weighing_unit : 'null',
      }

      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.productDetail.product_family == 'cannabis'){
        obj.cannabis_attributes = this.productDetail.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.productDetail.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
       
        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        if(this.is_user_logged_in == false){
          // If guest user 
          this.va_snackbar({
            message:  res.data.msg,
            type: 'success',
          });
        } else {
          // Description is not allowed on add to cart so add once its done for vbout
          //  obj.description = this.productDetail.description; not any more
          // lets save the data on vbout
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
       
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.productDetail.id,
              name: this.productDetail.name, 
              brand: this.productDetail.brand ? this.productDetail.brand.name : null,
              category: this.productDetail.category ? this.productDetail.category.name : null,
              variant: this.selectedVariant.size ? this.selectedVariant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
            }
          ]
        });
        return true;
      }
  
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data.payload[0],
        type: res.status == 200 ? 'success' : 'error',
      });
      return false;
 
    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(this.qty);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.is_user_logged_in == false){
          // If guest user 
          this.va_snackbar({
            message:  res.data.msg,
            type: 'success',
          });
        } else {
         // For vbout only push current added because its add api not update api
          obj.unit = parseInt(this.qty);
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        return true;
      } 
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : res.response.data.payload[0],
        type: res.response.status == 200 ? 'success' : 'error',
      });
      return false;
    },

    /**
     * Increase qty
     */
    increaseQty() {
      this.qty = this.qty + 1;
    },
    /**
     * Decrease qty
     */
    decreaseQty() {
      if(this.qty > 1){
        this.qty = this.qty - 1;
      }
    },

    refineQuery(query) {
      let removeObj = ['category', 'verify_email', 'token'];
      removeObj.forEach( (item) => {
        if(query.hasOwnProperty(item)){
          delete query[item];
        } 
      })
      return query;
    },

    closeModal() {
      this.loaded = false;
      this.qty = 1;
      this.totalNumberOfAddableVariants = 0,
      this.loaded = false,
      this.productDetail = {       
      };
      this.location_product_variants = [];
      this.data = {
        modal: false,
        product: {},
      };
      this.selectedVariant = {
      };
      this.success = false;
    },

    /**
     * Fav product
     */
    async favouriteProduct() {
      if(!this.$store.getters.getLoggedInUserId){
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;  
      }
      this.va_spinner(true);
      let res = await UserApis.addFavProduct({
        location_id: this.vg_selectedStore.id,
        location_product_id: this.productDetail.id
      });
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 201 ? res.data.msg : 'Please try again later.',
        type: res.status == 201 ? 'success' : 'error',
      });
    },

    /**
     * Unfav product
     */
    async unFavouriteProduct() {
      if(!this.$store.getters.getLoggedInUserId){
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      let res = await UserApis.removeFavProduct({
        location_id: this.vg_selectedStore.id,
        location_product_id: this.productDetail.id
      });
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : 'Please try again later.',
        type: res.status == 200 ? 'success' : 'error',
      });
    },

    variantHasSalePrice(item) {
      if(parseFloat(item.sale_price) > 0 && (parseFloat(item.sale_price) < parseFloat(item.price)) ){
        return true;
      }
      return false;
    },

    variantSalePercentage(item) {
      let salePercentData =  ((item.price-item.sale_price) / item.price)*100;
      return ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% off';
    },

     selectedLocationVariants(product_family, variants) {
      // First create unique variant and then on that variant add _is_stock_key
      let getUniqueProductVarinats = Helpers.getUniqueProductVariants(product_family, variants);
      return Helpers.attachOutOfStockKey(getUniqueProductVarinats);
    },

     /**
     * Check empty
     */
    isEmptyObj(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    /**
     * Generate product url 
     */
    // getProductFullUrl(product_id) {
    //   if(!product_id){
    //     return '';
    //   }
    //   let thisRoute = this.$router.resolve({
    //     name: 'LocationProductDetail',
    //      params: {
    //       business_slug: this.$route.params.business_slug,
    //       store_slug: this.$route.params.store_slug,
    //       product_id: product_id
    //     }
    //   })
    //   return window.location.protocol + "//" + window.location.host + thisRoute.href;
    // },

    /**
     * Generate Cart url 
     */
    // getCartFullUrl() {
    //   let thisRoute = this.$router.resolve({
    //     name: 'Cart',
    //      params: {
    //       business_slug: this.$route.params.business_slug,
    //       store_slug: this.$route.params.store_slug,
    //     }
    //   })
    //   return window.location.protocol + "//" + window.location.host + thisRoute.href;
    // },

    viewCart() {
      this.closeModal();
      bus.$emit('open-sidebar-cart', true);
    },

    itemPricePerWeight(variant) {
       // DO not show price per gram for non dried flower
      if(this.productDetail.cannabis_attributes && ( (this.productDetail.cannabis_attributes.product_form == 'dried flower' ) || (this.productDetail.cannabis_attributes.product_form == 'pre rolled') ) ){
        if(variant && (variant.weight_equivalent_dry_cannabis != null) ){
          let dryEquiWeight = parseFloat(variant.weight_equivalent_dry_cannabis);
          if(variant.sale_price && (variant.sale_price < variant.price) ){
            if(dryEquiWeight == 0){
              return '<span class="price has-text-dark">$' + (variant.sale_price).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
            }
            return '<span class="price has-text-dark">$' + (variant.sale_price/dryEquiWeight).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
          }
          if(dryEquiWeight == 0){
              return '<span class="price has-text-dark">$' + (variant.price).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
            }
          return  '<span class="price has-text-dark">$' + (variant.price/dryEquiWeight).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
        }
      } else {
        return ''; // return blank for now
        if(variant.sale_price && (variant.sale_price < variant.price) ){
          return '<span class="price has-text-dark">$' + (variant.sale_price).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
        } else {
          return '<span class="price has-text-dark">$' + (variant.price).toFixed(2) + '/' + this.productDetail.weighing_unit + '</span>';
        }
      }
    },

    ...mapActions({
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })

  },
};
</script>